import { Trans } from '@lingui/macro';
import { observer } from 'mobx-react-lite';
import React, { FC, useEffect, useState, useContext } from 'react';
import { BallTriangle } from 'react-loader-spinner';
import { Context } from '../..';
import AlumniService from '../../services/AlumniService';
import { ModalPopover } from './modal/modal-popover';
import ReactPaginate from 'react-paginate';
import { useNavigate } from 'react-router-dom';

const Video: FC<any> = observer(({ video, setDelVideoId, setDelVideoModal }) => {
    const { store } = useContext(Context);
    const navigate = useNavigate();

    const date = video['create_date'].split('T');
    const formattedDate = date[0].split('-');
    // setVideoDate(`${formattedDate[2]}.${formattedDate[1]}.${formattedDate[0]}`);
    return (
        <div className={"col-md-2 mt-2 mb-2" + (window.innerWidth > 480 ? ' h-100' : '')}>
            <div style={{ cursor: "pointer" }} onClick={() => {
                navigate(`/alumni_videos/${video['id']}`)

            }}>
                <hr />
                <div className="mb-3 img_wrap position-relative">
                    <iframe src={video['video_link']} title={`video_${video['id']}`} width="100%" height="100%"></iframe>
                    <div style={{ position: 'absolute', width: '100%', height: '100%', zIndex: '1000', bottom: '0px' }}></div>
                </div>
                <div className="mb-3">
                    <div className="text-end">{formattedDate[2]}.{formattedDate[1]}.{formattedDate[0]}</div>
                </div>
                <div className="mb-3">
                    <h6>{video['header'].substring(0, 100) + (video['header'].length < 100 ? '' : '...')}</h6>
                </div>
                <div>
                    {video['alumni_fio']}
                </div>
                <div>
                    {video['school']}
                </div>
                <div className="mb-3">
                    {video['municipality']}
                </div>
            </div>
            {
                store.user.is_superuser ?
                    <div onClick={() => {
                        setDelVideoId(video['id']);
                        setDelVideoModal(true);
                    }}>
                        <i className='icon trash ms-3' />
                        <Trans>Delete</Trans>
                    </div>
                    : null
            }
        </div >
    )
});


const ListPaginate = () => {
    const { store } = useContext(Context);
    const onPageChange = ({ selected }: { selected: number }) => {
        store.setAlumniPage(++selected);
    }
    return store.alumniPages > 1 ? (
        <nav aria-label="Page navigation">
            <ReactPaginate
                pageCount={store.alumniPages}
                forcePage={store.alumniPage - 1}
                marginPagesDisplayed={1}
                pageRangeDisplayed={5}
                onPageChange={onPageChange}
                containerClassName={'pagination justify-content-end'}
                pageClassName={'page-item'}
                pageLinkClassName={'page-link'}
                activeClassName={'active'}
                previousLabel={'<'}
                previousClassName={'d-none'}
                previousLinkClassName={'page-link'}
                nextLabel={'>'}
                nextClassName={'d-none'}
                nextLinkClassName={'page-link'}
                breakLabel={'...'}
                breakClassName={'page-item'}
                breakLinkClassName={'page-link'}
            />
        </nav>
    ) : null;
};



const Videos: FC = () => {
    const { store } = useContext(Context);
    const [videos, setVideos] = useState<[]>([]);
    const [loader, setLoader] = useState<boolean>(false);
    const [delVideoId, setDelVideoId] = useState<number>(-1);
    const [delVideoModal, setDelVideoModal] = useState<boolean>(false);

    const getVideos = async () => {
        const videos = await AlumniService.getVideos(store.alumniPage);
        setVideos(videos.data.results);
        store.setAlumniPages(Math.ceil(videos.data.count / 6))
        setLoader(false);
    };

    useEffect(() => {
        setLoader(true);
        getVideos();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [store.alumniPage]);

    const getItems = () => videos.sort((a, b) => b['id'] - a['id']).map((video, i) => {
        return <Video key={i} {...{ video, setDelVideoId, setDelVideoModal }} />
    })

    const deleteVideo = async () => {
        await AlumniService.removeVideo(delVideoId);
        getVideos();
        setDelVideoModal(false);
        setDelVideoId(-1);
    };


    return (loader ? <div className='row justify-content-center'><div className='col-md-2 mt-5'><BallTriangle color="#1d7ea7" height={90} width={90} /></div></div> :
        <div className="m-3">
            <div className="row">
                <ListPaginate />
                <div className="row pb-5">
                    {getItems()}
                </div>
                {/* <ListPaginate /> */}
            </div>
            <ModalPopover
                toggle={delVideoModal}
                setToggle={setDelVideoModal}
                title={store.lang === 'ba' ? 'Видеоны алып ташлау' : store.lang === 'ru' ? 'Удаление видео' : 'Deleting an video'}
                modalContent={<Trans>Do you want to delete a video?</Trans>}
                clickedButtonOne={() => deleteVideo()}
                clickedButtonTwo={() => { setDelVideoModal(false); setDelVideoId(-1); }}
                ButtonOneValue={store.lang === 'ba' ? 'Эйе' : store.lang === 'ru' ? 'Да' : 'Yes'}
                ButtonTwoValue={store.lang === 'ba' ? 'Кире ҡайтарыу' : store.lang === 'ru' ? 'Отмена' : 'Cancel'}
            />
        </div>
    )
};
export default observer(Videos);